import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "select-box_container" }
const _hoisted_2 = {
  key: 0,
  class: "select-box__label"
}
const _hoisted_3 = { class: "select-box__label-text" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["onClick"]

import { ref, watch, computed, onMounted, onUnmounted, nextTick } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import ErrorMessage from './ErrorMessage.vue';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectInput',
  props: {
    index: {},
    modelValue: {},
    options: {},
    placeholder: {},
    label: {},
    disabled: { type: Boolean },
    isError: { type: Boolean },
    errorMessage: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

// const selected = ref<string>(props.modelValue);
const selected = computed({
  /**
   * 選択された値を取得します。
   * @returns - 選択された値
   */
  get: () => props.modelValue,
  /**
   * 選択された値を設定します。
   * @param value - 選択された値
   */
  set: (value: string) => {
    emit('update:modelValue', value);
  },
});

const isOpen = ref(false);

const emit = __emit;

watch(
  () => props.modelValue,
  () => {
    selected.value = props.modelValue;
  }
);

/**
 * placeholderを表示するかどうか
 */
const isPlaceholder = computed(() => {
  return selected.value === '' || selected.value === null || selected.value === undefined;
});

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  if (!props.disabled) {
    isOpen.value = !isOpen.value;
  }
};

/**
 * オプションを選択し、親コンポーネントに選択値を通知します。
 * @param option - 選択されたオプション
 */
const selectOption = (option: string) => {
  selected.value = option;
  emit('update:modelValue', option);
  isOpen.value = false;
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!isOpen.value) return;
  const target = event.target;
  const selector = `#order-status-select-${props.index}`;
  const arrowSelector = `#order-status-select-arrow-${props.index}`;
  if (!(target instanceof Element)) return;
  if (target.closest(arrowSelector)) return;
  if (target.closest(selector)) return;

  isOpen.value = false;
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
  window.addEventListener('resize', calculateDropdownPosition);
  window.addEventListener('scroll', calculateDropdownPosition, true);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
  window.removeEventListener('resize', calculateDropdownPosition);
  window.removeEventListener('scroll', calculateDropdownPosition, true);
});

/**
 * ドロップダウンの位置を計算し、設定します。
 */
const calculateDropdownPosition = () => {
  nextTick(() => {
    const selectBox = document.querySelector(`#order-status-select-${props.index}`) as HTMLElement;
    if (selectBox) {
      const rect = selectBox.getBoundingClientRect();
      const dropdown = document.querySelector(`#order-status-select-dropdown-${props.index}`) as HTMLElement;
      if (dropdown) {
        dropdown.style.left = `${rect.left}px`; // スクロールを考慮した絶対位置
        dropdown.style.top = `${rect.bottom}px`; // スクロールを考慮した絶対位置
        dropdown.style.width = `${rect.width}px`; // select-boxの幅に合わせて設定

        // max-heightを計算して設定
        const availableHeight = window.innerHeight - rect.bottom - 10; // 10pxは少しのマージン
        dropdown.style.maxHeight = `${Math.max(availableHeight, 100)}px`; // 最小高さを100pxとする
        dropdown.style.overflowY = 'auto'; // スクロール可能にする
      }
    }
  });
};

watch(isOpen, (newVal) => {
  if (newVal) {
    calculateDropdownPosition();

    // ドロップダウンが開いたときに選択された要素をスクロールして表示する
    nextTick(() => {
      const dropdown = document.querySelector(`#order-status-select-dropdown-${props.index}`);
      const selectedEl = dropdown?.querySelector('.select-box__option--selected') as HTMLElement | null;

      if (dropdown && selectedEl) {
        const dropdownHeight = dropdown.clientHeight;
        const optionTop = selectedEl.offsetTop;

        // 表示枠の高さより選択肢の上が下すぎたら限界までスクロール、それ以外は上に来るように
        const scrollTop = Math.min(optionTop, dropdown.scrollHeight - dropdownHeight);
        dropdown.scrollTop = scrollTop;
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.label), 1),
          _createVNode(ErrorMessage, {
            "is-error": _ctx.isError,
            "error-message": _ctx.errorMessage
          }, null, 8, ["is-error", "error-message"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: `order-status-select-${_ctx.index}`,
      class: "select-box"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["select-box__selected", { 'select-box__selected--disabled': _ctx.disabled, 'select-box__selected--error': _ctx.isError }]),
        onClick: toggleDropdown
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`select-box__field ${isPlaceholder.value ? 'select-box__field--placeholder' : ''} ${
            _ctx.disabled ? 'select-box__selected--disabled' : ''
          }`)
        }, [
          _createElementVNode("div", null, _toDisplayString(isPlaceholder.value ? _ctx.placeholder : selected.value), 1)
        ], 2),
        (isOpen.value)
          ? (_openBlock(), _createBlock(SvgLoader, {
              key: 0,
              name: "arrowUp",
              class: "select-box__arrow"
            }))
          : (_openBlock(), _createBlock(SvgLoader, {
              key: 1,
              id: `order-status-select-arrow-${_ctx.index}`,
              name: "arrowDown",
              class: "select-box__arrow"
            }, null, 8, ["id"]))
      ], 2),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: `order-status-select-dropdown-${_ctx.index}`,
            class: "select-box__dropdown"
          }, [
            _createElementVNode("div", {
              class: "select-box__option",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (selectOption('')))
            }, _toDisplayString(_unref(t)('選択を外す')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option,
                class: _normalizeClass(["select-box__option", { 'select-box__option--selected': selected.value === option }]),
                onClick: ($event: any) => (selectOption(option))
              }, _toDisplayString(option), 11, _hoisted_6))
            }), 128))
          ], 8, _hoisted_5))
        : _createCommentVNode("", true)
    ], 8, _hoisted_4)
  ]))
}
}

})